import classNames from "classnames/bind";
import styles from "./DetailInfo.module.css";
import image from "../../../../../../assets/images/Avatar.png";
import { useEffect, useState } from "react";
import { listObjectFSR } from "../../../../../../services/api/listObjectFSR";
import { DownIcons } from "../../../../../../components/Icons/Icons";
import { Loading } from "../../../../../../components";
import { UpIcons } from "../../../../../../components/Icons/SideBar/UpIcons";
const cx = classNames.bind(styles);

const DetailInfo = ({ info }) => {
  const [infoDetail, setInfoDetail] = useState({})
  const [showInfo, setShowInfo] = useState(true)
  const [loadingImg, setLoadingImg] = useState(true)
  // // console.log(info);
  useEffect(() => {
    const getInfoByCode = async () => {
      try {
        const res = await listObjectFSR.getById(info.object_id)
        // // console.log(res);
        setInfoDetail(res?.data);
      } catch (error) {
        // console.log(error);
      }
    }
    if (info?.object_id !== "doituongla") {
      getInfoByCode()
    } else {
      setInfoDetail({
        departmentName: "Không rõ",
        staffName: "Đối tượng lạ"
      })
    }
  }, [info])

  const getListNameDepartment = (listDp) => {
    return (
      <>
        {listDp?.map((dp, index) => {
          return <span key={dp?.id} className={cx('department-name')}>{dp?.name}{index !== listDp?.length - 1 ? ", " : ''}</span>
        })}
      </>
    )
  }

  const handleShowInfo = () => {
    setShowInfo(!showInfo)
    setLoadingImg(true)
  }

  useEffect(() => {
    const timeOut = setTimeout(() => {
      setLoadingImg(false)
    }, 500)
    return () => clearTimeout(timeOut)
  }, [showInfo])

  return (
    <div className={cx("container")}>
      <div className={cx('header-control')}>
        <h3 className={cx("header")}>Thông tin chi tiết</h3>
        {info?.path && <span className={cx('button_show')} onClick={handleShowInfo}>{showInfo ? <UpIcons /> : <DownIcons />}</span>}
      </div>
      {showInfo ? (
        <div className={cx("body")}>
          <div className={cx("image-object")}>
            <img
              alt="no-img"
              src={info?.path ? `${process.env.REACT_APP_FSR_IP}${info?.path}` : image}
              style={{ height: "100%" }}
            />
            {loadingImg && <div className={cx("loading_modal")}>
              <Loading />
            </div>}

          </div>
          <div className={cx("info-object")}>
            <div className={cx("row-info")}>
              <label className={cx("label-info")}>Camera</label>
              <div className={cx("content-info")}>
                {info?.nameCamera ? info?.nameCamera : ''}
              </div>
            </div>
            <div className={cx("row-info")}>
              <label className={cx("label-info")}>Thời gian:</label>
              <div className={cx("content-info")}>
                {info.time}
              </div>
            </div>
            <div className={cx("row-info")}>
              <label className={cx("label-info")}>Phòng ban:</label>
              <div className={cx("content-info")}>
                {infoDetail?.departmentName || ''}
              </div>
            </div>

            <div className={cx("row-info")}>
              <label className={cx("label-info")}>Tên nhân viên:</label>
              <div className={cx("content-info")}>
                {infoDetail?.staffName || ''}
              </div>

            </div>
          </div>
        </div>
      ) : <></>}
    </div>
  );
};

export default DetailInfo;
